import { Injectable } from "@angular/core";
import { PromiseLookupService } from "../../impl/PromiseLookupService";
import { ITimezonePromiseLookupService } from "../ITimezonePromiseLookupService";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

export abstract class TimezonePromiseLookupService
  extends PromiseLookupService<string, CubiqTS.TimeZoneImpl>
  implements ITimezonePromiseLookupService
{
  constructor() {
    super();
    // debugger;
  }
  abstract getTimezone(id: string): Promise<CubiqTS.TimeZoneImpl>;
  abstract getAllTimezones(): Promise<Array<CubiqTS.TimeZoneImpl>>;
}
